module.exports = __webpack_public_path__ + "static/media/noimg.00eeaf45.jpg";